import { Divider } from '@mui/material';
import {
  AdvancedSearchProps,
  ChipsInput,
  SimpleSelect,
} from '@prismamedia/one-components';
import { useGetCategory } from 'apollo/queries/categories.recipe.graphql';
import clsx from 'clsx';
import { CategorySelect } from 'components/CategorySelect';
import { TagsSelect } from 'components/TagsSelect';
import {
  calorieLevels,
  difficulties,
  estimatedCosts,
  timeValues,
} from 'const/selectsValues';
import { FC } from 'react';
import { useStyles } from './styles';

export const AdvancedSearch: FC<AdvancedSearchProps> = ({
  searchParams,
  updateSearchParam,
  brandKey,
}) => {
  const classes = useStyles();
  const { data } = useGetCategory(searchParams.mainCategory);

  return (
    <>
      <div className={classes.section}>
        <CategorySelect
          label="Catégorie principale"
          category={data?.category}
          onSelect={(cat) => {
            updateSearchParam('mainCategory')(cat?.id);
          }}
          className={classes.input}
          brandKey={brandKey}
          displayCount
        />
        <TagsSelect
          value={searchParams.tags}
          onChange={updateSearchParam('tags')}
          className={classes.input}
        />
        <ChipsInput
          label="Ingrédients"
          value={searchParams.ingredients}
          onChange={updateSearchParam('ingredients')}
          className={classes.input}
        />
      </div>
      <Divider />
      <div className={classes.section}>
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Difficulté"
          variant="standard"
          options={difficulties}
          value={searchParams.difficulty}
          onChange={(_, value) => updateSearchParam('difficulty')(value)}
        />
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Niveau de prix"
          variant="standard"
          options={estimatedCosts}
          value={searchParams.estimatedCost}
          onChange={(_, value) => updateSearchParam('estimatedCost')(value)}
        />
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Taux de calories"
          variant="standard"
          options={calorieLevels}
          value={searchParams.calorieLevel}
          onChange={(_, value) => updateSearchParam('calorieLevel')(value)}
        />
      </div>
      <Divider />
      <div className={classes.section}>
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Temps de préparation"
          variant="standard"
          options={timeValues}
          value={
            searchParams.maxPrepTime ? String(searchParams.maxPrepTime) : ''
          }
          onChange={(_, value) =>
            updateSearchParam('maxPrepTime')(Number(value))
          }
        />
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Temps de cuisson"
          variant="standard"
          options={timeValues}
          value={
            searchParams.maxCookTime ? String(searchParams.maxCookTime) : ''
          }
          onChange={(_, value) =>
            updateSearchParam('maxCookTime')(Number(value))
          }
        />
        <SimpleSelect
          className={clsx(classes.input, classes.flexInput)}
          label="Temps d'attente"
          variant="standard"
          options={timeValues}
          value={
            searchParams.maxWaitTime ? String(searchParams.maxWaitTime) : ''
          }
          onChange={(_, value) =>
            updateSearchParam('maxWaitTime')(Number(value))
          }
        />
      </div>
    </>
  );
};
